import { isEmpty } from 'lodash';

let content_blocks = require('../contents');
let background_colors = [];

export function init(microsite_id, content_id){
    background_colors = window.background_colors;

    $('#edit_slide').find('.btn.btn-danger.delete_media').each(function(){
        $(this).on('click', function() {
            let modal = $(this).closest('.modal');
            let block_id = modal.find('[name="slide_id"]').val();
            let block = $('#'+ block_id);
            let background = JSON.parse(block.attr('data-background'));
            let media_id = background.media_id;
            content_blocks.delete_media(media_id);
            background['media_id'] = '';
            background['url'] = '';
            background['img_name'] = '';
            block.attr('data-background', JSON.stringify(background));
        })
    });

    $('#edit_slider_modal .btn.delete').on('click', function(){

        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();

        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');
        modal.find('form')[0].reset();

    });

    $('#edit_slider').find('.visibility-devices span').each(function(){
        $(this).on('click', function(){
            let hidden = $(this).attr('data-hidden') == true || $(this).attr('data-hidden') == 'true' ? true : false;
            change_device_visible($(this), !hidden);
            $(this).attr('data-hidden', !hidden);
        });
    });

    function change_device_visible(button, hidden){
        if (hidden == true || hidden == 'true') {
            button.css({"background-color": "#f8f9fa"});
        } else {
            button.css({"background-color": "#d3d6d9"});
        }
    }

    $('#edit_slider_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        let device_mobile = modal.find('.visibility-devices [data-device="mobile"]');
        device_mobile.attr('data-hidden', block.attr('data-mobile-hidden'));
        change_device_visible(device_mobile, block.attr('data-mobile-hidden'));
        
        let device_tablet = modal.find('.visibility-devices  [data-device="tablet"]');
        device_tablet.attr('data-hidden', block.attr('data-tablet-hidden'));
        change_device_visible(device_tablet, block.attr('data-tablet-hidden'));
        
        let device_desktop = modal.find('.visibility-devices [data-device="desktop"]');
        device_desktop.attr('data-hidden', block.attr('data-desktop-hidden'));
        change_device_visible(device_desktop, block.attr('data-desktop-hidden'));

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));
        modal.find('[name="full_width"]').prop('checked', block.attr('data-full-width') == 'true' ? true : false);
        modal.find('[name="autoplay"]').prop('checked', block.attr('data-autoplay') == 'true' ? true : false);
        modal.find('[name="interval"]').val(block.attr('data-interval'));
        modal.find('[name="show_index"]').prop('checked', block.attr('data-show-index') == '1' ? true : false);

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_slider').on('submit', function (e) {
        e.preventDefault();
        let block = $('#'+ $(this).find('[name="block_id"]').val());

        let device_mobile = $(this).find('.visibility-devices [data-device="mobile"]');
        block.attr('data-mobile-hidden', device_mobile.attr('data-hidden'));
        
        let device_tablet = $(this).find('.visibility-devices  [data-device="tablet"]');
        block.attr('data-tablet-hidden', device_tablet.attr('data-hidden'));
        
        let device_desktop = $(this).find('.visibility-devices [data-device="desktop"]');
        block.attr('data-desktop-hidden', device_desktop.attr('data-hidden'));
        
        block.attr('data-full-width', $(this).find('[name="full_width"]').prop('checked'));
        block.attr('data-autoplay', $(this).find('[name="autoplay"]').prop('checked'));
        block.attr('data-interval', $(this).find('[name="interval"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-show-index', $(this).find('[name="show_index"]').prop('checked') ? 1 : 0);
        block.attr('data-visible', $(this).find('[name="visible"]').val());
        
        content_blocks.change_visible_button_blocks(block);

        let modal = $(this).closest('.modal');
        modal.modal('hide');

        $(this)[0].reset();
    });

    $('#add_slide_modal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let prev_slide = $(button).closest('.slide');
        let modal = $(this);
        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="prev_slide_id"]').val(prev_slide.attr('id'));

        let size_select = modal.find('select[name="bg-size"]');
        let position_select = modal.find('select[name="bg-position"]');
        let color_select = modal.find('select[name="bg-color"]');
        let select_visible = modal.find('[name="visible"]');

        size_select.find('option:nth-child(1)').prop('selected', true);
        position_select.find('option:nth-child(1)').prop('selected', true);
        color_select.find('option:nth-child(1)').prop('selected', true);
        select_visible.find('option[value="visible"]').prop('selected', true);

        size_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
        position_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
        color_select.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });
    });

    $('#edit_slide_modal .btn.delete').on('click', function(){
        
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="slide_id"]').val();
        let slider_id = $('#'+block_id).closest('.block').attr('id');
        $('#'+block_id).remove();
        
        // content_blocks.show_start_block();
        // content_blocks.show_block_order();

        show_block_order(slider_id);
        init_slider_block(slider_id);

        modal.modal('hide');
        modal.find('form')[0].reset();

    });

    $('#edit_slide').on("submit", function(e) {
        e.preventDefault();

        let form = $(this);
        let url = form.find('[name="url"]').val();
        let link_type = form.find('[name="link_type"]').val();

        if (link_type != 'external_link') {
            let url_post = window._routes['microsites.contents.block.check_link_slug'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);
    
            let form_data = new FormData();
            form_data.append('link_type', link_type);
            form_data.append('slug', url);
    
            window.forms.post(url_post, form_data, true, true)
                .then((response) => {
                    if (response.data == true) {
                        save_slide_atributes(form);
                    } else {
                        window.messages.error(__('No existe el slug indicado'));
                    }
                })
                .catch((error) => {
                    console.log('ERROR', error);
                })
                .finally(() => {
                    window.blockui.release();
                });
        } else {
            save_slide_atributes(form);
        }

    });

    $('#add_slide').on("submit", function(e) {
        e.preventDefault();

        let form_data = new FormData($(this)[0]);
        form_data.append('new_block_id', window.app.microsites.contents.get_random_id(10));
        form_data.append('type', 'slide');
        form_data.append('blank', $(this).find('[name="blank"]').prop('checked'));
        form_data.append('nofollow', $(this).find('[name="nofollow"]').prop('checked'));
        
        let translations = {};
        for(let _language of window._content_languages){
            translations[_language] = {'title': '', 'subtitle': '', 'text': '', 'call_to_action': '', 'url': '', 'background': '[]'};
            translations[_language]['title'] = form_data.get('title');
            translations[_language]['subtitle'] = form_data.get('subtitle');
            translations[_language]['text'] = form_data.get('text') ?? '';
            translations[_language]['call_to_action'] = form_data.get('call_to_action') ?? '';
            translations[_language]['url'] = form_data.get('url') ?? '';
        }

        form_data.append('translations', JSON.stringify(translations));

        let modal = $(this).closest('.modal');
        modal.modal('hide');
        $(this)[0].reset();

        get_slide_view(form_data);
        
    });

    $('#content_blocks .slides').each(function(){
        init_slides($(this).attr('id'));
    });

    $('.block[data-type="slider"]').each(function(){
        init_slider_block($(this).attr('id'));
        content_blocks.create_visible_button_blocks($(this));
    });
}

function save_slide_atributes(form) {

    let slide = $('#'+ form.find('[name="slide_id"]').val());

    let title = form.find('[name="title"]').val();
    let subtitle = form.find('[name="subtitle"]').val();
    let text = form.find('[name="text"]').val();
    let call_to_action = form.find('[name="call_to_action"]').val();
    let url = form.find('[name="url"]').val();
    let link_type = form.find('[name="link_type"]').val();
    let background = JSON.parse(slide.attr('data-background'));
    background['color'] = form.find('[name="bg-color"]').val();
    background['size'] = form.find('[name="bg-size"]').val();
    background['position'] = form.find('[name="bg-position"]').val();

    if (link_type == 'external_link' && url != '') {
        //url ha de empezar por http:// o https://
        const patronURL = /^(https?:\/\/)/;
        if (!patronURL.test(url)) {
            url = 'https://'+url;
        }
    }

    let translations = [];
    if(window._content_languages.length > 1){

        try {
            translations = JSON.parse(slide.attr('data-translations'));
            if (typeof translations == 'string') {
                translations = [];
            }

        } catch(err){
            translations = [];
        }

        // preparo traducciones que no existan

        for(let _language of window._content_languages){
            if(typeof translations[_language] == 'undefined'){
                translations[_language] = { 'title': title, 'subtitle': subtitle, 'text': text, 'call_to_action': call_to_action, 'url': url};
            }
            if(typeof translations[_language]['background'] == 'undefined'){
                translations[_language]['background'] =  background;
            }
        }

        // guardo tranduccion actual 

        translations[window._content_selected_language]['title'] = title;
        translations[window._content_selected_language]['subtitle'] = subtitle;
        translations[window._content_selected_language]['text'] = text;
        translations[window._content_selected_language]['call_to_action'] = call_to_action;
        translations[window._content_selected_language]['url'] = url;
        translations[window._content_selected_language]['background']['color'] = background['color'];
        translations[window._content_selected_language]['background']['size'] = background['size'];
        translations[window._content_selected_language]['background']['position'] = background['position'];

        // si es idioma base

        if(window._content_selected_language == window._locale){

            slide.attr('data-title', title);
            slide.attr('data-subtitle', subtitle);
            slide.attr('data-text', text);
            slide.attr('data-call-to-action', call_to_action);
            slide.attr('data-url', url);
            slide.attr('data-background', JSON.stringify(background));

            // actualizamos traducciones vacias

            for(let _language of window._content_languages){
                if(_language != window._locale){
                    if(translations[_language]['title'] == ''){
                        translations[_language]['title'] = title;
                    }

                    if(translations[_language]['subtitle'] == ''){
                        translations[_language]['subtitle'] = subtitle;
                    }

                    if(translations[_language]['text'] == ''){
                        translations[_language]['text'] = text;
                    }

                    if(translations[_language]['call_to_action'] == ''){
                        translations[_language]['call_to_action'] = call_to_action;
                    }

                    if(translations[_language]['url'] == ''){
                        translations[_language]['url'] = url;
                    }
                    
                    if(typeof translations[_language]['background'] == 'undefined' || translations[_language]['background'] == []){
                        translations[_language]['background'] = background;
                        // translations[_language]['background']['color'] = background['color'];
                        // translations[_language]['background']['size'] = background['size'];
                        // translations[_language]['background']['position'] = background['position'];
                        // translations[_language]['background']['img_name'] = background['img_name'];
                        // translations[_language]['background']['media_id'] = background['media_id'];
                        // translations[_language]['background']['src'] = background['src'];
                    }
                }
            }
        }

        if (link_type != 'external_link' || slide.attr('data-link-type') != link_type) {
            for(let _language of window._content_languages){
                translations[_language]['url'] = url;
            }
        }

    } else {

        slide.attr('data-title', title);
        slide.attr('data-subtitle', subtitle);
        slide.attr('data-text', text);
        slide.attr('data-call-to-action', call_to_action);
        slide.attr('data-url', url);

        slide.attr('data-background', JSON.stringify(background));
    }

    slide.attr('data-class', form.find('[name="classes"]').val());
    slide.attr('data-visible', form.find('[name="visible"]').val());
    slide.attr('data-link-type', link_type);
    slide.attr('data-blank', form.find('[name="blank"]').prop('checked'));
    slide.attr('data-nofollow', form.find('[name="nofollow"]').prop('checked'));
    slide.attr('data-translations', JSON.stringify(translations));

    let form_data = new FormData(form[0]);
    form_data.append('new_block_id', form.find('[name="slide_id"]').val());
    form_data.append('type', 'slide');
    if (background['url'] != null || background['url'] != 'undefined') {
        form_data.append('bg-url', background['url']);
    }
    if (form_data.get('media').name != '') {
        update_slide_image(form_data, slide);
    }

    content_blocks.change_visible_button_blocks(slide);

    let card_body = slide.find('.card-body');
    card_body.html(create_preview(title, subtitle, text, !isEmpty(translations) ? translations[window._content_selected_language]['background'] : background, call_to_action));
    let modal = form.closest('.modal');
    modal.modal('hide');
    
    form[0].reset();
}

export function get_slide_view(form_data) {

    let url = window._routes['microsites.contents.block'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    window.forms.post(url, form_data, true, true)
            .then((response) => {
                
                if (response.data.prev_slide_id != null) {
                    $('#' + response.data.prev_slide_id).after(response.data.slide);
                } else {
                    $('#' + response.data.slider_id + ' .slides').append(response.data.slide);
                }

                let slide = $('#'+ response.data.slide_id);
                slide.attr('data-class', form_data.get("classes"));
                slide.attr('data-title', form_data.get("title"));
                slide.attr('data-subtitle', form_data.get("subtitle"));
                slide.attr('data-text', form_data.get("text"));
                slide.attr('data-call-to-action', form_data.get("call_to_action"));
                slide.attr('data-url', form_data.get("url"));
                slide.attr('data-link-type', form_data.get("link_type"));

                let background = JSON.parse(slide.attr('data-background'));
                background['color'] = form_data.get("bg-color");
                background['size'] = form_data.get("bg-size");
                background['position'] = form_data.get("bg-position");
                slide.attr('data-background', JSON.stringify(background));

                init_slides(response.data.slider_id);
                init_slider_block(response.data.slider_id);
            })
            .catch((error) => {
                console.log('ERROR', error);
            })
            .finally(() => {
                window.blockui.release();
            });
}

export function show_block_order(slider_id){

    let slides = $('#' + slider_id +' .slides .slide');

    if (slides.length > 1) {

        for(let i=0; i<slides.length; i++){

            $(slides[i]).find('.slide_up').show().prop('disabled', i == 0);
            $(slides[i]).find('.slide_down').show().prop('disabled', i == slides.length - 1);
            $(slides[i]).find('.move_slide').show();
    
            content_blocks.show_block_order($(slides[i]).attr('id'));
        }

    } else {

        for(let i=0; i<slides.length; i++){

            $(slides[i]).find('.slide_up').hide().prop('disabled', i == 0);
            $(slides[i]).find('.slide_down').hide().prop('disabled', i == slides.length - 1);
            $(slides[i]).find('.move_slide').hide();
    
            content_blocks.show_block_order($(slides[i]).attr('id'));
        }
    }
}

export function init_slides(slider_id){

    $('#content_blocks #' + slider_id + ' .slides .slide:not(.init)').each(function(){
        let slide_id = $(this).attr('id');

        $('#' + slide_id).find('.btn.slide_up').click(function(){
                
            let slider_id = $(this).closest('.block[data-type="slider"]').attr('id');
            
            let slide = $(this).closest('.slide');
            let prev_slide = slide.prev();
            slide.detach();
            prev_slide.before(slide);

            show_block_order(slider_id);

        });

        $('#' + slide_id).find('.btn.slide_down').click(function(){
            let slider_id = $(this).closest('.block[data-type="slider"]').attr('id');
            let slide = $(this).closest('.slide');
            let next_slide = slide.next();
            slide.detach();
            next_slide.after(slide);
            
            show_block_order(slider_id);
        });

        $('#' + slide_id).find('.btn.slide_edit').click(function(){
            
            let form = $('#edit_slide');
            let slide = $(this).closest('.slide');
            let block = $(this).closest('.block');

            let title = slide.attr('data-title');
            let subtitle = slide.attr('data-subtitle');
            let text = slide.attr('data-text');
            let call_to_action = slide.attr('data-call-to-action');
            let url = slide.attr('data-url');
            let background = JSON.parse(slide.attr('data-background'));
            let translations = [];

            try {

                translations = JSON.parse(slide.attr('data-translations'));
                if(typeof translations[window._content_selected_language] != 'undefined'){
                    
                    if(typeof translations[window._content_selected_language]['title'] != 'undefined'){
                        title = translations[window._content_selected_language]['title'];
                    }

                    if(typeof translations[window._content_selected_language]['subtitle'] != 'undefined'){
                        subtitle = translations[window._content_selected_language]['subtitle'];
                    }

                    if(typeof translations[window._content_selected_language]['text'] != 'undefined'){
                        text = translations[window._content_selected_language]['text'];
                    }

                    if(typeof translations[window._content_selected_language]['call_to_action'] != 'undefined'){
                        call_to_action = translations[window._content_selected_language]['call_to_action'];
                    }

                    if(typeof translations[window._content_selected_language]['url'] != 'undefined'){
                        url = translations[window._content_selected_language]['url'];
                    }
                    
                    if(typeof translations[window._content_selected_language]['background'] != 'undefined'){
                        background['color'] = translations[window._content_selected_language]['background']['color'];
                        background['img_name'] = translations[window._content_selected_language]['background']['img_name'];
                        background['url'] = translations[window._content_selected_language]['background']['url'];
                        background['media_id'] = translations[window._content_selected_language]['background']['media_id'];
                    }

                }
            } catch(err){
                console.log(err);
            }

            form.find('[name="block_id"]').val(block.attr('id'));
            form.find('[name="slide_id"]').val(slide.attr('id'));
            form.find('[name="classes"]').val(slide.attr('data-class'));
            form.find('[name="title"]').val(title);
            form.find('[name="subtitle"]').val(subtitle);
            form.find('[name="text"]').val(text);
            form.find('[name="call_to_action"]').val(call_to_action);
            form.find('[name="url"]').val(url);
            form.find('[name="blank"]').prop('checked', slide.attr('data-blank') == 'true' ? true : false);
            form.find('[name="nofollow"]').prop('checked', slide.attr('data-nofollow') == 'true' ? true : false);


            let select_link_type = form.find('[name="link_type"]');
            if (slide.attr('data-link-type') != null || slide.attr('data-link-type') != 'undefined') {
                select_link_type.find('option[value="'+ slide.attr('data-link-type')).prop('selected', true);
            } else {
                select_link_type.find('option[value="external_link"]').prop('selected', true);
            }
            
            select_link_type.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });

            form.find('[name="bg-color"]').val(background['color']);
            let size_select = form.find('select[name="bg-size"]');
            let position_select = form.find('select[name="bg-position"]');
            let color_select = form.find('select[name="bg-color"]');
            let select_visible = form.find('[name="visible"]');

            if (background['color'] != null) {
                color_select.find('option[value="'+ background['color'] +'"]').prop('selected', true);
            } else {
                color_select.find('option:nth-child(1)').prop('selected', true);
            }
            color_select.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });

            if (background['size'] != null || background['size'] != 'undefined') {
                size_select.find('option[value="'+ background['size'] +'"]').prop('selected', true);
            } else {
                size_select.find('option:nth-child(1)').prop('selected', true);
            }
            size_select.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });
    
            if (background['position'] != null || background['position'] != 'undefined') {
                position_select.find('option[value="'+ background['position'] +'"]').prop('selected', true);
            } else {
                position_select.find('option:nth-child(1)').prop('selected', true);
            }
            position_select.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });

            
            if (slide.attr('data-visible') != null || slide.attr('data-visible') != 'undefined') {
                select_visible.find('option[value="'+ slide.attr('data-visible')).prop('selected', true);
            } else {
                select_visible.find('option[value="visible"]').prop('selected', true);
            }
            
            select_visible.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });


            let image = form.find('input[name="media"]');
            let label = image.next('label');
            label.text(background['img_name']);
        });


        content_blocks.change_visible_button_blocks($(this));
        // inicializar bloque
        $(this).addClass('init');
        
    });

    show_block_order(slider_id);

}

export function init_slider_block(block_id) {

    let block = $('#content_blocks #' + block_id);
    let card_body = block.find('.card-body');
    let card_empty_body = block.find('.card-empty-body');
    if (card_body.find('.slide').length <= 0) {
        card_empty_body.removeClass('d-none');
        card_empty_body.addClass(['d-flex', 'justify-content-center']);
    } else {
        card_empty_body.addClass('d-none');
        card_empty_body.removeClass('d-flex');
    }

    $('#content_blocks #' + block_id + ' .slides .move_slide').each(function(){

        $(this)[0].addEventListener("dragstart", (event) => {
            event.stopPropagation();

            let container = $(event.target).closest('.drag-container');
            container.addClass('dragging');

            let slide = $(event.target).closest('.slide');

            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', slide.attr('id'));

            var dragImage = document.createElement('div');
            dragImage.id = 'drag-handler';
            dragImage.innerHTML = '<i class="fa-solid fa-plane"></i>';
            dragImage.setAttribute('style', 'position: absolute; left: 0px; top: 0px; width: 30px; height: 30px; z-index: -1');
            document.body.appendChild(dragImage);
            event.dataTransfer.setDragImage(dragImage, 20, 20);

        });
    
        $(this)[0].addEventListener("dragend", (event) => {
        
            $('#drag-handler').remove();
            
            let container = $(event.target).closest('.drag-container');
            container.removeClass('dragging');
    
        });

    });

    $('#content_blocks #' + block_id + ' .slides > .slide > .btn-drop').each(function(){
        
        $(this)[0].addEventListener("dragover", (event) => {
            event.preventDefault();
        });

        $(this)[0].addEventListener("dragenter", (event) => {
            event.preventDefault();
            if(event.dataTransfer.getData('text/plain') != $(event.target).closest('.slide').attr('id')){
                $(event.target).addClass('drop');
            }
        });

        $(this)[0].addEventListener("dragleave", (event) => {
            event.preventDefault();
            $(event.target).removeClass('drop');
        });
    
        $(this)[0].addEventListener("drop", (event) => {
            event.stopPropagation();

            let slide = $('#' + event.dataTransfer.getData('text/plain'));
            let move_after = $(event.target).closest('.slide');

            if(
                slide.length > 0 
                && move_after.length > 0
                && slide.attr('id') != move_after.attr('id')
            ){
                move_after.after(slide.detach());
            }
        });

    });

}

function update_slide_image(form_data, slide) {
    let url = window._routes['microsites.contents.media'].replace('{microsite}', window.microsite_id).replace('{content}', window.content_id);

    form_data.append('type', slide.attr('data-type'));
    window.forms.post(url, form_data, true, true)
        .then((response) => {

            if (response.data != null) {
                let background = JSON.parse(slide.attr('data-background'));
                background['url'] = response.data.src;
                background['img_name'] = response.data.name;
                background['media_id'] = response.data.media_id;
                slide.attr('data-background', JSON.stringify(background));

                if(window._content_languages.length > 1){
                    
                    translations = JSON.parse(slide.attr('data-translations'));
                    
                    translations[window._content_selected_language]['background']['url'] = response.data.src;
                    translations[window._content_selected_language]['background']['media_id'] = response.data.media_id;
                    translations[window._content_selected_language]['background']['img_name'] = response.data.name;
    
                    slide.attr('data-translations', JSON.stringify(translations));
                }

                let card_body = slide.find('.card-body');
                card_body.children().css({'background-image': 'url('+background['url']+')'});
            }
                            
        })
        .catch((error) => {
            console.log('ERROR', error);
        })
        .finally(() => {
            window.blockui.release();
        });
}

function create_preview(title, subtitle, text, background, call_to_action) {

    let background_color = '';
    let type_color = background.color ?? '';
    if (type_color != '') {
        let version_color = background_colors[type_color];
        let color = version_color['color'];
        let opacity = version_color['shade'];
        background_color = background_colors['colors'][color][opacity];
    }

    let div = '<div class="wrapper" style="'+
            'background-color: '+background_color+';'+
            'background-image: url('+background["url"]+');'+
            'background-size: '+background["size"]+';'+
            'background-position: '+background["position"]+';'+
        '">'+
            '<div>'+
                '<h5 class="trans title">'+title+'</h5>';
                    div += '<b class="trans subtitle">'+subtitle+'</b><br/>';
                    div += '<span class="trans text">'+text+'</span><br/>';
                    div += '<button type="button" class="btn btn-xs btn-secondary trans call_to_action">'+call_to_action +'</button>';
            div+='</div>'+
        '</div>';

    return div;
}
